import * as Sentry from '@sentry/react';
import { type ReactElement, type ReactNode } from 'react';

import { ErrorState } from '@/components/error-state.tsx';

type FallbackProps = Parameters<Sentry.FallbackRender>[0];

interface Props {
    children: ReactNode;
    routeName: string;
}

const fallback = (props: FallbackProps): ReactElement => {
    const handleRetry = (): void => props.resetError();
    return <ErrorState onRetry={handleRetry} />;
};

export const RouteErrorBoundary = ({ children, routeName }: Props) => {
    return (
        <Sentry.ErrorBoundary
            fallback={fallback}
            beforeCapture={(scope) => {
                scope.setTag('boundary', 'route');
                scope.setTag('route', routeName);
            }}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
};
